import template from './myLoansRequestCadastral.html';
import controller from './myLoansRequestCadastral.controller';
import './myLoansRequestCadastral.scss';

let myLoansRequestCadastralComponent = {
  restrict: 'E',
  bindings: {
    error: '<',
    messageError: '<',
    onCloseModalCadastral: '&',
  },
  template,
  controller
};

export default myLoansRequestCadastralComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/modals/myLoansRequestCadastral/myLoansRequestCadastral.component.js